// document.addEventListener("DOMContentLoaded", function () {
//   var slides = document.querySelectorAll("#flavor-slider .slider-slide");
//   var currentSlide = 0;
//   var prevBtn = document.getElementById("prevBtn");
//   var nextBtn = document.getElementById("nextBtn");
//   var pagination = document.getElementById("pagination");

//   function showSlide(index) {
//     var offset = -index * 100 + "%";
//     for (var i = 0; i < slides.length; i++) {
//       slides[i].style.transform = "translateX(" + offset + ")";
//       // slides[i].style.transform = "translate3d(" + offset + ", 0, 0, 0)";

//       slides[i].classList.remove("c-active"); // Remove active class from all slides
//     }
//     slides[index].classList.add("c-active"); // Add active class to the current slide
//     currentSlide = index;
//     updatePagination();
//   }

//   function nextSlide() {
//     currentSlide++;
//     if (currentSlide >= slides.length) {
//       currentSlide = 0;
//     }
//     showSlide(currentSlide);
//   }

//   function prevSlide() {
//     currentSlide--;
//     if (currentSlide < 0) {
//       currentSlide = slides.length - 1;
//     }
//     showSlide(currentSlide);
//   }

//   function updatePagination() {
//     var dots = "";
//     for (var i = 0; i < slides.length; i++) {
//       var activeClass = i === currentSlide ? "active" : "";
//       dots += `<span class="pagination-dot ${activeClass}" data-slide="${i}"></span>`;
//     }
//     pagination.innerHTML = dots;
//     addPaginationListeners();
//   }

//   function addPaginationListeners() {
//     var paginationDots = pagination.querySelectorAll(".pagination-dot");
//     paginationDots.forEach(function (dot) {
//       dot.addEventListener("click", function () {
//         var slideIndex = parseInt(this.getAttribute("data-slide"));
//         showSlide(slideIndex);
//       });
//     });
//   }

//   showSlide(currentSlide);
//   nextBtn.addEventListener("click", nextSlide);
//   prevBtn.addEventListener("click", prevSlide);
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var slides = document.querySelectorAll("#flavor-slider .slider-slide");
//   var sliderContainer = document.getElementById("flavor-slider");
//   var currentSlide = 0;
//   var prevBtn = document.getElementById("prevBtn");
//   var nextBtn = document.getElementById("nextBtn");
//   var pagination = document.getElementById("pagination");

//   function showSlide(index) {
//     if (index < 0) {
//       index = slides.length - 1;
//     } else if (index >= slides.length) {
//       index = 0;
//     }

//     var offset = -index * 100 + "%";
//     sliderContainer.style.transform = "translateX(" + offset + ")";
//     for (var i = 0; i < slides.length; i++) {
//       slides[i].classList.remove("c-active");
//     }

//     slides[index].classList.add("c-active");
//     currentSlide = index;
//     updatePagination();
//   }

//   function nextSlide() {
//     showSlide(currentSlide + 1);
//   }

//   function prevSlide() {
//     showSlide(currentSlide - 1);
//   }

//   function updatePagination() {
//     pagination.innerHTML = "";
//     for (var i = 0; i < slides.length; i++) {
//       var dot = document.createElement("span");
//       dot.classList.add("pagination-dot");
//       if (i === currentSlide) {
//         dot.classList.add("active");
//       }
//       dot.setAttribute("data-slide", i);
//       dot.addEventListener("click", function () {
//         var slideIndex = parseInt(this.getAttribute("data-slide"));
//         showSlide(slideIndex);
//       });
//       pagination.appendChild(dot);
//     }
//   }

//   showSlide(currentSlide);
//   nextBtn.addEventListener("click", nextSlide);
//   prevBtn.addEventListener("click", prevSlide);

//   const variantSelect = document.getElementById('variant-select');
// if (variantSelect) {
//   variantSelect.addEventListener('change', (event) => {
//     const selectedOption = event.target.selectedOptions[0];
//     if (selectedOption) {
//       const textContent = selectedOption.textContent;
//       console.log(textContent);
//     } else {
//       console.error('No option selected');
//     }
//   });
// } else {
//   console.error('Variant select element not found');
// }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var slides = document.querySelectorAll("#second-slider .slider-slide");
//   var currentSlide = 0;
//   var slidesToShow = 3; // Number of slides to show at once
//   var prevBtn = document.getElementById("sec-prevBtn");
//   var nextBtn = document.getElementById("sec-nextBtn");
//   var pagination = document.getElementById("pagination");

//   function showSlide(index) {
//     // Calculate the starting index of the current set of slides to show
//     var startIndex = index * slidesToShow;
//     // Calculate the ending index of the current set of slides to show
//     var endIndex = startIndex + slidesToShow;

//     // Loop through all slides and show/hide based on the calculated indices
//     for (var i = 0; i < slides.length; i++) {
//       if (i >= startIndex && i < endIndex) {
//         slides[i].style.display = "block";
//       } else {
//         slides[i].style.display = "none";
//       }
//       slides[i].classList.remove("active"); // Remove active class from all slides
//     }

//     // Add active class to the current slide
//     slides[index * slidesToShow].classList.add("active");
//     currentSlide = index;
//     updatePagination();
//   }

//   function nextSlide() {
//     currentSlide++;
//     if (currentSlide >= Math.ceil(slides.length / slidesToShow)) {
//       currentSlide = 0;
//     }
//     showSlide(currentSlide);
//   }

//   function prevSlide() {
//     currentSlide--;
//     if (currentSlide < 0) {
//       currentSlide = Math.ceil(slides.length / slidesToShow) - 1;
//     }
//     showSlide(currentSlide);
//   }

//   function updatePagination() {
//     var dots = "";
//     for (var i = 0; i < Math.ceil(slides.length / slidesToShow); i++) {
//       var activeClass = i === currentSlide ? "active" : "";
//       dots += `<span class="pagination-dot ${activeClass}" data-slide="${i}"></span>`;
//     }
//     pagination.innerHTML = dots;
//     addPaginationListeners();
//   }

//   function addPaginationListeners() {
//     var paginationDots = pagination.querySelectorAll(".pagination-dot");
//     paginationDots.forEach(function (dot) {
//       dot.addEventListener("click", function () {
//         var slideIndex = parseInt(this.getAttribute("data-slide"));
//         showSlide(slideIndex);
//       });
//     });
//   }

//   showSlide(currentSlide);
//   nextBtn.addEventListener("click", nextSlide);
//   prevBtn.addEventListener("click", prevSlide);
// });
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelector(".header h2").innerHTML = "abcd";
// });
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        const slideCartElement = document.querySelector(".slidecarthq");

        if (slideCartElement) {
          // Now your code will run when #slidecarthq is detected in the DOM
          observer.disconnect(); // Stop observing once the element is found

          // Your code to update .slidecarthq .header
          const headerElement = document.querySelector(
            ".slidecarthq .header h2"
          );
          if (headerElement) {
            headerElement.innerHTML = `<div class="shoping-cart"><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/Vector_Smart_Object.png?v=1722713507" /><h2>Shopping Cart<span class="cart-count">Good Choice Partner. Let's Ride!</span></h2></div>`;
          }

          // Your code to update #slidecart-checkout-form button
          const checkoutButton = document.querySelector(
            "#slidecart-checkout-form button"
          );
          if (checkoutButton) {
            checkoutButton.innerHTML = `<span class="left-vehicle-image"><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/stagecoach.png?v=1722756879" /><span class="checkout-class">Secure Checkout</span></span><span class="right-arrow-image"><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/Group_25.png?v=1722756880" /></span>`;
          }

          // Your code to update the footer
          const footerRows = document.querySelectorAll(
            "#slidecarthq .footer .footer-row"
          );

          if (footerRows.length >= 2) {
            const secondFooterRow = footerRows[1];
            const subImageElement = secondFooterRow.querySelector(".flex");
            const fireImage = document.createElement("strong");
            fireImage.classList.add("fire-image");
            fireImage.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/bold-flavor-icon.png?v=1719247734"/>`;

            if (secondFooterRow) {
              secondFooterRow.prepend(fireImage);
            }
            const flexElement = secondFooterRow.querySelector(".flex");
            if (flexElement) {
              flexElement.innerHTML = "Subtotal";
            }
          }
        }
      }
    }
  });

  // Start observing the document for changes
  observer.observe(document.body, { childList: true, subtree: true });
});

// Product detail scroll issue work
const variantClickCustomHandler = () => {
  const previousScrollHeight = window.scrollY;
  window.scrollTo(0, previousScrollHeight);

  for (let i = 0; i < 500; i++) {
    setTimeout(() => {
      window.scrollTo(0, previousScrollHeight);
    }, i);
  }
};

const selectVariantBtns = document.querySelectorAll(
  ".template-product .product-variant__item--radio"
);

selectVariantBtns.forEach((singleSelector) => {
  singleSelector.addEventListener("click", variantClickCustomHandler);
});
const selectPlusBtn = document.querySelector(".template-product .qty-plus");
const selectMinusBtn = document.querySelector(".template-product .qty-minus");
const selectPlusMinusInput = document.querySelector(
  ".template-product .product__quantity"
);
// function QuantityPlusMinus() {
//   const originalPricePerItem = document.querySelector(
//     "#originalProductPrice"
//   ).value;
//   const updateQuantity = (increment) => {
//     let currentQuantity = parseInt(selectPlusMinusInput.value);

//     currentQuantity += increment;

//     console.log({ currentQuantity }, "currentQuantitycurrentQuantity");

//     if (currentQuantity < 1) {
//       currentQuantity = 1;
//     }

//     console.log({ increment, currentQuantity }, "currentQuantity");

//     selectPlusMinusInput.value = currentQuantity;

//     const updatedPrice = originalPricePerItem * currentQuantity;
//     document.querySelector(
//       ".product-price--original"
//     ).innerText = `$${updatedPrice.toFixed(2)}`;
//   };

//   selectPlusBtn.addEventListener("click", () => {
//     updateQuantity(1);
//   });

//   selectMinusBtn.addEventListener("click", () => {
//     updateQuantity(-1);
//   });
// }
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const getOriginalPrice = document.querySelector(".product-price--original");

    const originalProductPriceValue = getOriginalPrice?.innerText?.replace(
      "$",
      ""
    );

    let hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "originalProductPrice";
    hiddenInput.id = "originalProductPrice";

    hiddenInput.value = originalProductPriceValue;

    document.body.append(hiddenInput);
  }, 1000);

  // QuantityPlusMinus();

  // const extraBtn = document.querySelectorAll(".pagination .lap-hide");
  // const prevElement = document.querySelector(".pagination .prev a");
  // const nextElement = document.querySelector(".pagination .next a");

  // extraBtn.forEach((single) => {
  //   single.style.display = "none";
  // });
  // prevElement.innerHTML = `<button class="pagination-back-btn">
  //   <img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/vector-left-arrow.png?v=1722935524" width="13px" height="13px">
  //   Back
  // </button>`
  // nextElement.innerHTML = `<button class="pagination-next-btn">
  //   Next
  //   <img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/vector-right-arrow.png?v=1722935525" width="13px" height="13px">
  // </button>`
});

document.addEventListener("DOMContentLoaded", () => {
  const qtyDropdownObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const qtyDropdown = entry.target;

        qtyDropdown.addEventListener("change", function (event) {
          const getOriginalPrice = document.querySelector(
            ".product-price--original"
          );
          const getHiddenOriginalPriceValue = document.querySelector(
            "#originalProductPrice"
          )?.value;

          if (getOriginalPrice && getHiddenOriginalPriceValue) {
            const multipliedValue =
              getHiddenOriginalPriceValue * event.target.value;
            getOriginalPrice.innerText = `$ ${multipliedValue.toFixed(2)}`;
          }
        });

        // Disconnect the observer after the event listener is added
        qtyDropdownObserver.disconnect();
      }
    });
  });

  // Start observing the qty dropdown element
  const qtyDropdownElement = document.querySelector(
    ".template-product #custom-qty-dropdown-detail-p"
  );
  if (qtyDropdownElement) {
    qtyDropdownObserver.observe(qtyDropdownElement);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const paginationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Your JavaScript to run when pagination is loaded
        document.querySelector(
          `.pagination .prev span[aria-hidden="true"]`
        ).innerHTML = `  <div class="next-page-custom-styling back-page-custom-styling">
          <div><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/black-arrow-icon.png?v=1719511448" width="50" height="50"></div>
          <div>Back</div> 
        </div>`;

        document.querySelector(
          `.pagination .next span[aria-hidden="true"]`
        ).innerHTML = `<div class="next-page-custom-styling">
                        <div> Next
                        </div> 
                        <div><img src="https://cdn.shopify.com/s/files/1/0637/9716/6216/files/black-arrow-icon.png?v=1719511448" width="50" height="50"></div>
                      </div>`;

        // Disconnect the observer after it has run once
        paginationObserver.disconnect();
      }
    });
  });

  // Start observing the pagination element
  const paginationElement = document.querySelector(
    "#main-collection-product-grid .pagination"
  );
  if (paginationElement) {
    paginationObserver.observe(paginationElement);
  }
}); 
document.addEventListener("DOMContentLoaded", function () { 
  const sidebar = document.getElementById("site-filters-sidebar");
  const closeSidebar = () => {
    sidebar.style.cssText =
      "transform: translate(100%);";
  };
  const openSidebar = () => {
    sidebar.style.cssText =
      "transform: translate(0%);";
  };
  Array.from(document.getElementsByClassName("sidebar__close")).forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      closeSidebar();
    });
  });
  const observer = new MutationObserver(function (mutationsList, observer) {
    document
    .getElementById("collection-filters-handle")
    .addEventListener("click", function (event) {
      event.preventDefault();
      console.log("Clicked open!");
      openSidebar();
    });

  });

  const observerConfig = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  };
  if (sidebar) {
    observer.observe(sidebar, observerConfig);
  }
});

